<div class="row h-100 gy-3">
  <div class="col-xl-5 col-xl1-3 col-addendums">
    <available-co-buyers-sidebar
      [prospectId]="effectiveProspectId()"
      [lotId]="effectiveLotId()"
      [linkedCoBuyerIds]="linkedCoBuyerIds()"
      [isActive]="isActive()"
      (coBuyerLinked)="onCoBuyerLinked()"
      [dealId]="effectiveDealId()"
    />
  </div>
  <div class="col-xl-7 col-xl1-9 h-100">
    <linked-co-buyers-table
      [linkedCoBuyersResource]="linkedCoBuyersResource"
      (coBuyerUnlinked)="onCoBuyerLinked()"
      [prospectId]="effectiveProspectId()"
    />
  </div>
</div>
